import React, { Suspense } from 'react'
import Card from 'src/components/Card'
import Body from './Body'
import List from './List'
import { EeocContextProvider } from 'src/pages/cat/candidates/Candidate/cards/EEOC/useEeoc'

interface ContactInfoProps {
  id: string
}

const ContactInfo: React.FC<ContactInfoProps> = (props) => {
  const { id } = props

  return (
    <>
      <Suspense fallback={<Card title='EEOC Paperwork'><List eeoc={undefined} /></Card>}>
        <EeocContextProvider candidate={id}>
          <Body id={id} />
        </EeocContextProvider>
      </Suspense>
    </>
  )
}

export default ContactInfo
